exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".org-multiple-select{cursor:pointer;position:relative}.org-select-dropdown{width:100%;position:absolute;z-index:1001;border-radius:4px;background-color:#fff;box-shadow:0 2px 12px 0 #eeeeee;box-sizing:border-box;margin:5px 0}\n", ""]);

